import { createStore } from 'satcheljs';
import { TxpSettingsDialogViewState } from './viewSchema/TxpSettingsDialogViewState';
import TxpSettingsDialogViewStates from './viewSchema/TxpSettingsDialogViewStates';

export interface TxpSettingsViewStateStore {
    txpSettingsDialogViewState: TxpSettingsDialogViewState;
    txpSettingsErrorDialogViewState: TxpSettingsDialogViewStates;
}

const initialTxpSettingsViewStateStore: TxpSettingsViewStateStore = {
    txpSettingsDialogViewState: {
        viewState: TxpSettingsDialogViewStates.Hidden,
        txpSettings: {
            CreateEventsFromEmailAsPrivate: undefined,
            EntityTypeSettings: {
                FlightReservation: {
                    ProcessingLevel: undefined,
                    FirstRunExperienceShown: undefined,
                },
                FoodEstablishmentReservation: {
                    ProcessingLevel: undefined,
                    FirstRunExperienceShown: undefined,
                },
                LodgingReservation: {
                    ProcessingLevel: undefined,
                    FirstRunExperienceShown: undefined,
                },
                RentalCarReservation: {
                    ProcessingLevel: undefined,
                    FirstRunExperienceShown: undefined,
                },
                ParcelDelivery: {
                    ProcessingLevel: undefined,
                    FirstRunExperienceShown: undefined,
                },
                EventReservation: {
                    ProcessingLevel: undefined,
                    FirstRunExperienceShown: undefined,
                },
                Invoice: {
                    ProcessingLevel: undefined,
                    FirstRunExperienceShown: undefined,
                },
                ServiceReservation: {
                    ProcessingLevel: undefined,
                    FirstRunExperienceShown: undefined,
                },
            },
        },
    },
    txpSettingsErrorDialogViewState: TxpSettingsDialogViewStates.Hidden,
};

const getStore = createStore<TxpSettingsViewStateStore>(
    'txpSettingsViewState',
    initialTxpSettingsViewStateStore
);
export default getStore;
